import { render, staticRenderFns } from "./feedBait_feedRecord_page.vue?vue&type=template&id=b14d9efe&scoped=true"
import script from "./feedBait_feedRecord_page.vue?vue&type=script&lang=js"
export * from "./feedBait_feedRecord_page.vue?vue&type=script&lang=js"
import style0 from "./feedBait_feedRecord_page.vue?vue&type=style&index=0&id=b14d9efe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14d9efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b14d9efe')) {
      api.createRecord('b14d9efe', component.options)
    } else {
      api.reload('b14d9efe', component.options)
    }
    module.hot.accept("./feedBait_feedRecord_page.vue?vue&type=template&id=b14d9efe&scoped=true", function () {
      api.rerender('b14d9efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/feeder/feedBait_feedRecord_page.vue"
export default component.exports